export const integerDivinding = (number) => {
  if (number % 1 >= 0.5) {
    return parseInt(number, 10) + 1
  }
  return parseInt(number, 10)
}

export default integerDivinding
